/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignaturePadBundlesCheckout } from '../../models/signature-pad-bundles-checkout';
import { Token64LengthType } from '../../models/token-64-length-type';

export interface ExternalGetDataForSignatureCheckout$Params {
  token: Token64LengthType;
}

export function externalGetDataForSignatureCheckout(http: HttpClient, rootUrl: string, params: ExternalGetDataForSignatureCheckout$Params, context?: HttpContext): Observable<StrictHttpResponse<SignaturePadBundlesCheckout>> {
  const rb = new RequestBuilder(rootUrl, externalGetDataForSignatureCheckout.PATH, 'get');
  if (params) {
    rb.query('token', params.token, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SignaturePadBundlesCheckout>;
    })
  );
}

externalGetDataForSignatureCheckout.PATH = '/external/signature-pads/checkout/bundle-data';
